import React from 'react'

const Tag = ({ children, ...props }) => {
  return (
    <hot-tag {...props} data-testid="tag">
      {children}
    </hot-tag>
  )
}

export default Tag
